import { Pipe, PipeTransform } from '@angular/core';
import { StringUtil } from '@libs/vc-core-lib';
import { ITaskSequenceNumberModel } from '../model/task-sequence-number.model';

@Pipe({
    name: 'sequenceNumber',
    standalone: true,
})
export class SequenceNumberFormatPipe implements PipeTransform {
    private static SEPARATOR: string = '.';
    transform(sequence: ITaskSequenceNumberModel, separator?: string) {
        const _separator =
            separator && StringUtil.isNotBlankWithTrim(separator) ? separator : SequenceNumberFormatPipe.SEPARATOR;
        let returnStr = '';
        if (sequence?.majorNumber) {
            returnStr = returnStr + sequence.majorNumber;
            if (sequence.minorNumber) {
                returnStr = returnStr + _separator + sequence.minorNumber;
            }
        }
        return returnStr;
    }
}
